import Component from './checkout'

export default Component